import {useNavigate} from 'react-router-dom';

import HomeIcon from '@mui/icons-material/HomeRounded';
import NavigateNextIcon from '@mui/icons-material/NavigateNextRounded';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import {routes} from '../../constants/routes';
import {
  type Breadcrumb,
  useBreadcrumbStore,
} from '../../stores/breadcrumbStore';

export function AppShellBreadcrumbs(): JSX.Element {
  const navigate = useNavigate();
  const breadcrumbs = useBreadcrumbStore((state) => state.breadcrumbs);

  return (
    <Breadcrumbs
      aria-label="breadcrumb"
      sx={{color: 'inherit'}}
      separator={<NavigateNextIcon fontSize="medium" color="primary" />}
    >
      <Stack
        sx={{cursor: breadcrumbs.length === 0 ? 'default' : 'pointer'}}
        direction="row"
        spacing={0.5}
        onClick={(event) => {
          if (event.metaKey || event.ctrlKey || event.shiftKey) {
            window.open(routes.landing, '_blank', 'noreferrer');
          } else {
            navigate(routes.landing);
          }
        }}
        onAuxClick={() => {
          window.open(routes.landing, '_blank', 'noreferrer');
        }}
      >
        <HomeIcon color={breadcrumbs.length > 0 ? 'primary' : 'action'} />
        <Typography
          variant="body1"
          fontWeight={breadcrumbs.length > 0 ? 600 : 400}
          color={breadcrumbs.length > 0 ? 'primary' : 'text.primary'}
        >
          Home
        </Typography>
      </Stack>
      {breadcrumbs.map((breadcrumb) => (
        <AppShellBreadcrumb
          key={breadcrumb.path ?? breadcrumb.label}
          breadcrumb={breadcrumb}
        />
      ))}
    </Breadcrumbs>
  );
}

interface AppShellTopBarBreadcrumbProps {
  breadcrumb: Breadcrumb;
}

function AppShellBreadcrumb({
  breadcrumb,
}: AppShellTopBarBreadcrumbProps): JSX.Element {
  const navigate = useNavigate();
  return (
    <Typography
      key={breadcrumb.path}
      sx={{cursor: !breadcrumb.path ? 'default' : 'pointer'}}
      variant="body1"
      fontWeight={400}
      color={'text.primary'}
      onClick={(event) => {
        if (breadcrumb.path) {
          if (event.metaKey || event.ctrlKey || event.shiftKey) {
            window.open(breadcrumb.path, '_blank', 'noreferrer');
          } else {
            navigate(breadcrumb.path);
          }
        }
      }}
      onAuxClick={() => {
        if (breadcrumb.path) {
          window.open(breadcrumb.path, '_blank', 'noreferrer');
        }
      }}
    >
      {breadcrumb.label}
    </Typography>
  );
}
